<h1 class="page-title">{{ 'VALIDATION_HISTORY_PAGE_TITLE' | translate }}</h1>
<p class="description mb-3">{{ 'VALIDATION_HISTORY_DESCRIPTION' | translate }}</p>

<ridango-date-period-selector
    [startDate]="startDate$ | async"
    [minStartDate]="minStartDate$ | async"
    [maxStartDate]="maxStartDate$ | async"
    [endDate]="endDate$ | async"
    [minEndDate]="minEndDate$ | async"
    [maxEndDate]="maxEndDate$ | async"
    [automaticEnd]="true"
    [diff]="diff$ | async"
    [dateFormat]="dateFormat"
    [showText]="false"
    [showPrint]="true"
    [useMaterialIcon]="true"
    (startDateSet)="startUpdated($event)"
    (endDateSet)="endUpdated($event)"
    (commitPeriodSelect)="updateList()"
    (print)="downloadValidationHistoryPdf()">
</ridango-date-period-selector>

<ridango-ui-basic-loading-spinner *ngIf="loading$ | async" [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
</ridango-ui-basic-loading-spinner>

<div
    class="purchase-detail-view-area-ticket"
    *ngIf="(loading$ | async) === false && (validations$ | async).length === 0">
    <p class="purchase-detail-view-area-ticket__title">{{ 'NO_VALIDATION_ACTIVITY_FOUND' | translate }}</p>
    <p class="purchase-detail-view-area-ticket__description">
        {{ 'NO_VALIDATION_ACTIVITY_FOUND_DESCRIPTION' | translate }}
    </p>
</div>

<section class="ridango-mat-table margin-top-20">
    <table
        *ngIf="(loading$ | async) === false && (validations$ | async).length > 0"
        [dataSource]="validations$ | async"
        [attr.aria-busy]="(loading$ | async) === false"
        mat-table>
        <ng-container matColumnDef="date">
            <th *matHeaderCellDef mat-header-cell>{{ 'VALIDATION_HISTORY_TABLE_HEADER_DATE' | translate }}</th>
            <td *matCellDef="let element" mat-cell>
                <span class="hide-desktop show-mobile">{{ 'VALIDATION_HISTORY_TABLE_HEADER_DATE' | translate }}</span>
                {{
                    element.validation_timestamp
                        | formatTimeZone: env.PRIMARY_DATE_FORMAT : appStartupService.getTimezone()
                }}
            </td>
        </ng-container>

        <ng-container matColumnDef="time">
            <th *matHeaderCellDef mat-header-cell>{{ 'VALIDATION_HISTORY_TABLE_HEADER_TIME' | translate }}</th>
            <td *matCellDef="let element" mat-cell>
                <span class="hide-desktop show-mobile">{{ 'VALIDATION_HISTORY_TABLE_HEADER_TIME' | translate }}</span>
                {{ element.validation_timestamp | formatTimeZone: 'HH:mm' : appStartupService.getTimezone() }}
            </td>
        </ng-container>

        <ng-container matColumnDef="medium">
            <th *matHeaderCellDef mat-header-cell>{{ 'VALIDATION_HISTORY_TABLE_HEADER_MEDIUM' | translate }}</th>
            <td *matCellDef="let element" mat-cell>
                <span class="hide-desktop show-mobile">{{ 'VALIDATION_HISTORY_TABLE_HEADER_MEDIUM' | translate }}</span>
                {{ element.medium }}
            </td>
        </ng-container>

        <ng-container matColumnDef="ticketName">
            <th *matHeaderCellDef mat-header-cell>{{ 'VALIDATION_HISTORY_TABLE_HEADER_TICKET_NAME' | translate }}</th>
            <td *matCellDef="let element" mat-cell>
                <span class="hide-desktop show-mobile">{{
                    'VALIDATION_HISTORY_TABLE_HEADER_TICKET_NAME' | translate
                }}</span>
                {{ element | translateObjectField: 'name' : translate.currentLang }}
            </td>
        </ng-container>

        <ng-container matColumnDef="lineName">
            <th *matHeaderCellDef mat-header-cell>{{ 'VALIDATION_HISTORY_TABLE_HEADER_LINE' | translate }}</th>
            <td *matCellDef="let element" mat-cell>
                <span class="hide-desktop show-mobile">{{ 'VALIDATION_HISTORY_TABLE_HEADER_LINE' | translate }}</span>
                {{ element.route_short_name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="lineStop">
            <th *matHeaderCellDef mat-header-cell>{{ 'VALIDATION_HISTORY_TABLE_HEADER_STOP' | translate }}</th>
            <td *matCellDef="let element" mat-cell>
                <span class="hide-desktop show-mobile">{{ 'VALIDATION_HISTORY_TABLE_HEADER_STOP' | translate }}</span>
                {{ element.stop_name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="lineZone">
            <th *matHeaderCellDef mat-header-cell>{{ 'VALIDATION_HISTORY_TABLE_HEADER_ZONE' | translate }}</th>
            <td *matCellDef="let element" mat-cell>
                <span class="hide-desktop show-mobile">{{ 'VALIDATION_HISTORY_TABLE_HEADER_ZONE' | translate }}</span>
                {{ element.zone }}
            </td>
        </ng-container>

        <tr *matHeaderRowDef="validationTableColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: validationTableColumns" mat-row></tr>
    </table>
</section>
